import React from 'react';

import Illustration from './Illustration';
import BlockContent from './BlockContent';

export default function RegularSection({ section }) {
  const { blockContent, illustration, assets } = section;

  const position = illustration?.position;
  const isTranslate = illustration?.isTranslate;
  const isBackgroundImage = illustration?.isBackgroundImage;

  const style = `regular-section ${
    position ? `--illustration-${position}` : ''
  } ${isTranslate ? `--illustration-translate-${position}` : ''}`;
  return (
    <>
      {section && (
        <>
          <div className={style}>
            <BlockContent content={blockContent} />
            {!isBackgroundImage && <Illustration illustration={illustration} />}
          </div>
          {assets && (
            <div className="assets">
              <>
                {assets.map((asset) => (
                  <div className="asset" key={asset.id}>
                    <Illustration illustration={asset} />
                    <p className="body --shadow-light --upper">{asset.title}</p>
                  </div>
                ))}
              </>
            </div>
          )}
        </>
      )}
    </>
  );
}
